export function getConfig() {
  const config = {};

  config.fontSize = Office.context.roamingSettings.get('fontSize');

  return config;
}

export function setConfig(config, callback) {
  Office.context.roamingSettings.set('fontSize', config.fontSize);

  Office.context.roamingSettings.saveAsync(callback);
}

export function getShowedFREVer() {

  const ver = Office.context.roamingSettings.get('showedFREVer');

  return ver;
}

export function setShowedFREVer(ver, callback) {
  Office.context.roamingSettings.set('showedFREVer', ver);

  Office.context.roamingSettings.saveAsync(callback);
}

export function updateFontSize(elementId, fontSize) 
{
  const $element = $('#' + elementId);
  const arrClass = $element.attr('class').split(/\s+/);
  let currentClass = "mw-font-m";
  $.each(arrClass, function (index, value) {
    if (value.toLowerCase().startsWith('mw-font-')) {
      currentClass = value;
      return false;
    }
  });

  $element.removeClass(currentClass).addClass("mw-font-" + fontSize);
}

export function getAbsoluteUrl(relativePath) {
  const a = document.createElement("a");
  a.href = relativePath;
  return a.href;
}